var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "Tabs",
        [
          _c(
            "Tab",
            { attrs: { name: "Detalle General", selected: "true" } },
            [
              _c("SimNumeroFormGeneral", {
                attrs: {
                  modoVer: true,
                  serieNumeroSeleccionado: _vm.serieNumeroSeleccionado
                }
              })
            ],
            1
          ),
          _c(
            "Tab",
            { attrs: { name: "Desactivadores" } },
            [
              _c("SimDesactivadoresForm", {
                attrs: {
                  modoVer: true,
                  serieNumeroSeleccionado: _vm.serieNumeroSeleccionado,
                  simestadolistSeleccionado: _vm.simestadolistSeleccionado
                }
              })
            ],
            1
          ),
          _c(
            "Tab",
            { attrs: { name: "Equipo Activado" } },
            [
              _c("EquipoActivoForm", {
                attrs: {
                  modoVer: true,
                  serieNumeroSeleccionado: _vm.serieNumeroSeleccionado,
                  tipoEquipoSeleccionado: _vm.tipoEquipoSeleccionado
                }
              })
            ],
            1
          ),
          _c(
            "Tab",
            { attrs: { name: "Movimientos" } },
            [
              _c("SimMovimientosForm", {
                attrs: {
                  modoVer: true,
                  serieNumeroSeleccionado: _vm.serieNumeroSeleccionado,
                  tipoEquipoSeleccionado: _vm.tipoEquipoSeleccionado
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }